
import { actionTypesForSignin, signinStatuses } from '../constants/signinOverlayConstants.js';

export const onSubmitEmail = (event) => {
    $('#signin-overlay-form').attr('action', secureBaseURL + 'common/signin_json.html?signintype=email');
    updateRedirectURLOnSigninForm();
};

export const onSubmitEmailAndPassword = (event) => {
    $('#signin-overlay-form').attr('action', secureBaseURL + 'common/signin_json.html?signintype=password');
    updateRedirectURLOnSigninForm();
};

export const onSendInstantSignin = (event) => {
    event.preventDefault();
    $('#signin-overlay-form').attr('action', secureBaseURL + 'common/signin_json.html?signintype=instant');
    updateRedirectURLOnSigninForm();
    $('#signin-overlay-form').submit();
};

export const onSendPasswordReset = (event) => {
    event.preventDefault();
    $('#signin-overlay-form').attr('action', secureBaseURL + 'common/signin_json.html?signintype=forgotpw');
    updateRedirectURLOnSigninForm();
    $('#signin-overlay-form').submit();
};

export const isEmailSent = (signinStatus) => {
    return signinStatus.indexOf('_SENT') > -1;
};

export const buildPageFromType = () => {
    var url = new Uri(window.location.href);
    if (url.getQueryParamValue('pageFromType')) {
        return decodeURIComponent(url.getQueryParamValue('pageFromType'));
    } else if (isGivingCartPopup()) {
        return 'cart';
    }
    return '';
};

export const buildRedirectURL = () => {
    var url = new Uri(window.location.href);
    if (window.customSigninRedirectURL) {
        return window.customSigninRedirectURL;
    } else if (url.getQueryParamValue('go')) {
        const goURL = new Uri(decodeURIComponent(url.getQueryParamValue('go')));
        if (!goURL.anchor() && url.anchor()) {
            goURL.setAnchor(url.anchor());
        }
        return goURL.toString();
    }
    if (checkoutSigninNoExkey && isGivingCartPopup()) {
        url.deleteQueryParam('execution');
        return url.toString();
    }
    return window.location.href;
};

export const updateRedirectURLOnSigninForm = () => {
    var redirectURL = buildRedirectURL();
    if ((new Uri(redirectURL)).path().includes('signin.html')) {
        $('#signin-overlay-form').find('[name=go]').val('');
    }
    $('#signin-overlay-form').find('[name=go]').val(redirectURL);
};

export const isRedirectURLFromCreateGivingPage = () => {
    var url = new Uri(buildRedirectURL());
    if (url && url.path().includes('customize_givingpage.html')) {
        return true;
    }
    return false;
};

export const getGivingPageCampaignFromRedirectURL = () => {
    if (isRedirectURLFromCreateGivingPage()) {
        var url = new Uri(buildRedirectURL());
        if (url && url.getQueryParamValue('campaign')) {
            return url.getQueryParamValue('campaign');
        }
    }
    return null;
};

export const isGivingCartPopup = () => {
    var url = new Uri(window.location.href);
    if (url.path().includes('givingCart.html')) {
        return true;
    }
    return false;
};

export const isContactPage = () => {
    var url = new Uri(window.location.href);
    if (url.path().includes('contact_form.html')) {
        return true;
    }
    return false;
};
